import {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {UserCheck} from 'lucide-react';
import {AlertBox} from '@chekin/guestapp-ui-kit';
import {PATHS} from 'routes/constants';
import {usePath} from 'hooks';
import Button from 'components/common/Button';
import styles from './styles.module.css';

function VerifyOnHousingView() {
  const {t} = useTranslation('identity-verification');
  const navigate = useNavigate();
  const {getFullPath} = usePath();

  const handleStart = useCallback(() => {
    navigate(getFullPath(PATHS.findReservationsByName), {replace: true});
  }, [navigate, getFullPath]);

  return (
    <div className={styles.verifyOnHousing_main}>
      <div className={styles.verifyOnHousing_content}>
        <div className={styles.verifyOnHousing_iconContainer}>
          <div className={styles.verifyOnHousing_iconBox}>
            <UserCheck
              size={48}
              className={styles.verifyOnHousing_iconBoxIcon}
              strokeWidth={1.5}
            />
          </div>
        </div>

        <div className={styles.verifyOnHousing_headingGroup}>
          <h1 className={styles.verifyOnHousing_heading}>
            {t('verify_identity_at_property')}
          </h1>
          <p className={styles.verifyOnHousing_description}>
            {t('enter_name_to_find_reservation')}
          </p>

          <AlertBox
            variant={'secondary'}
            text={t('you_will_asked_to_scan_id_and_selfie')}
          />
        </div>

        <Button className="mt-4" label={t('start')} onClick={handleStart} />
      </div>
    </div>
  );
}

export {VerifyOnHousingView};
